(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pxl-slider"] && !Shopify.designMode) return;
  try {
    
const slider = document.querySelector('.js-slider')

if (slider) {
   const loop = slider.getAttribute('data-autorotate') === 'true'
   const delay = slider.getAttribute('data-speed')

   const mySwiper = new Swiper('.js-slider', {
      loop,
      autoplay: {
         delay,
      },
      pagination: {
         el: '.swiper-pagination',
         clickable: true
      },
      navigation: {
         nextEl: '.swiper-button-next',
         prevEl: '.swiper-button-prev',
      },
   })
}

document.querySelectorAll('.countdown').forEach(cd => {
  const end = new Date(cd.dataset.end).getTime();

  const daysEl = cd.querySelector('.cd-days');
  const hoursEl = cd.querySelector('.cd-hours');
  const minutesEl = cd.querySelector('.cd-minutes');
  const secondsEl = cd.querySelector('.cd-seconds');

  function updateCountdown() {
    const now = new Date().getTime();
    const distance = end - now;

    if (distance <= 0) {
      cd.querySelector('.countdown__timer').innerHTML = "Finalizado";
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    daysEl.textContent = days;
    hoursEl.textContent = hours;
    minutesEl.textContent = minutes;
    secondsEl.textContent = seconds;
  }

  updateCountdown();
  setInterval(updateCountdown, 1000);
});




  } catch(e) { console.error(e); }
})();
})();
